import { render, staticRenderFns } from "./scrapDetails.vue?vue&type=template&id=328b9206&scoped=true"
import script from "./scrapDetails.vue?vue&type=script&lang=js"
export * from "./scrapDetails.vue?vue&type=script&lang=js"
import style0 from "./scrapDetails.vue?vue&type=style&index=0&id=328b9206&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328b9206",
  null
  
)

export default component.exports